import React from 'react';
import { ShoppingBagIcon } from './icons';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  className?: string;
}
export function CtaButton({
  children,
  href = '#offer',
  size = 'default',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-10 py-5 text-sm sm:text-base' : 'px-8 py-4 text-xs sm:text-sm';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Ballet Teacher Elite System',
      value: 27,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center gap-3 rounded-full bg-wine font-sans font-semibold uppercase tracking-[0.12em] text-cream shadow-[0_16px_34px_-18px_rgba(122,59,69,0.85)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-charcoal hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-wine active:translate-y-0 ${sizing} ${className}`} data-id="element-42" data-mp="109257418t602">
      <ShoppingBagIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-43" data-mp="39zj2026hglyq" />
      <span style={{
      fontSize: "15px"
    }} data-id="element-44" data-mp="3exb0jf1mv6bw">{children}</span>
    </a>;
}